import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./common/PrivateRoute";
import "react-phone-number-input/style.css";

import "./theme.css";
import Login from "./components/Login";
import Register from "./components/Registration";
import LandingPage from "./components/LandingPage";
import Dashboard from "./pages/Dashboard/Dashboard";
import ForgotPasswordPage from "./components/ForgotPasswordPage"
import ScrollToTop from "./components/ScrollToTop";
import RoleRoute from "./common/RoleRoute";
import Loader from "./components/Skeleton/Loader";
// import DemoPage from "./pages/Demo/DemoPage";
// import { ThemeContext } from "./context/ThemeContext";
import { useHostMiddleware } from './common/useHostMiddleware';
import { ThemeProvider } from './context/ThemeContext';
import Calculators from "./pages/AITools/Calculators/Calculators";
import TenantTitle from "./components/TenantTitle";

const PlanSet = lazy(() => import("./pages/Planset/PlansetMain/PlanSet"));
const PlansetOrder = lazy(() => import("./pages/Planset/CreatePlanset/PlansetOrder"));
const PlansetView = lazy(() => import("./pages/Planset/ViewPlanset/PlansetView"));
const TeamMain = lazy(() => import("./pages/Team/TeamMain/TeamMain"));
const ClientMain = lazy(() => import("./pages/Clients/ClientMain/ClientMain"));
const PEStamp = lazy(() => import("./pages/PEStamp/PEStampMain/PEStamp"));
const PEStampView = lazy(() => import("./pages/PEStamp/ViewPEStamp/PEStampView"));
const PEStampOrder = lazy(() => import("./pages/PEStamp/CreatePEStamp/PEStampOrder"));
const SalesProposal = lazy(() => import("./pages/SalesProposal/SalesProposalMain/SalesProposal"));
const SalesProposalView = lazy(() => import("./pages/SalesProposal/ViewSalesProposal/SalesProposalView"));
const SalesProposalOrder = lazy(() => import("./pages/SalesProposal/CreateSalesProposal/SalesProposalOrder"));
const PTO = lazy(() => import("./pages/PTO/PTOMain/PTO"));
const PTOOrder = lazy(() => import("./pages/PTO/CreatePTO/PTOOrder"));
const PTOView = lazy(() => import("./pages/PTO/ViewPTO/PTOView"));
const StampingPartners = lazy(() => import("./pages/StampingPartners/StampingPartners"));
const Archive = lazy(() => import("./pages/Archive/Archive"));
const SiteSurvey = lazy(() => import("./pages/SiteSurvey/SiteSurvey"));
const Leads = lazy(() => import("./pages/Leads/Leads"));
const Chats = lazy(() => import("./pages/Chats/Chats"));
const About = lazy(() => import("./pages/About/About"));
const ReviewWithAI = lazy(() => import("./pages/ReviewWithAI/ReviewWithAI"));
const Verification = lazy(() => import("./pages/Verification/Verification"));
const NotFound = lazy(() => import("./pages/404/NotFound"));
const HomePage = lazy(() => import("./pages/Homepage/Homepage"));

function App() {
  const { isOwner} = useHostMiddleware();
  if (process.env.NODE_ENV === "development") {
    console.log("Running in DEV mode");
  }
  // const { loading } = React.useContext(ThemeContext);

  // if (loading) {
  //   return (
  //     <Loader/>
  //   );
  // }
  if (isOwner) {
    return (
      <Router>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/calculator" element={<Calculators />} />
          </Routes>
        </Suspense>
      </Router>
    );
  }

  return (
      <ThemeProvider>
        <TenantTitle/>
    <Router>
      <ScrollToTop/>
      <Suspense fallback={<Loader/>}>
        <Routes>
          {console.log(isOwner)}
          <Route path="/" element={isOwner ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />} />
          <Route path="/home" element={<HomePage />} />
          {/*<Route path="/demo" element={<DemoPage />} />*/}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/forgotpassword/:token?" element={<ForgotPasswordPage />} />
          <Route element={<PrivateRoute><LandingPage /></PrivateRoute>}>
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/salesproposal" element={<PrivateRoute>   <RoleRoute blockedRoles={[4]}> <SalesProposal /></RoleRoute> </PrivateRoute>} />
            <Route path="/salesproposal/view" element={<PrivateRoute> <RoleRoute blockedRoles={[4]}> <SalesProposalView /></RoleRoute></PrivateRoute>} />
            <Route path="/salesproposal/order" element={ <PrivateRoute> <RoleRoute blockedRoles={[4]}> <SalesProposalOrder /> </RoleRoute> </PrivateRoute> }/>
            <Route path="/pestamp" element={<PrivateRoute><PEStamp /></PrivateRoute>} />
            <Route path="/pestamp/view" element={<PrivateRoute><PEStampView /></PrivateRoute>} />
            <Route path="/pestamp/order" element={<PrivateRoute><PEStampOrder /></PrivateRoute>} />
            <Route path="/pto" element={<PrivateRoute><PTO /></PrivateRoute>} />
            <Route path="/pto/order" element={<PrivateRoute><PTOOrder /></PrivateRoute>} />
            <Route path="/pto/view" element={<PrivateRoute><PTOView /></PrivateRoute>} />
            <Route path="/chats" element={<PrivateRoute><Chats /></PrivateRoute>} />
            <Route path="/archive" element={<PrivateRoute><Archive /></PrivateRoute>} />
            <Route path="/sitesurvey" element={<PrivateRoute><SiteSurvey /></PrivateRoute>} />
            <Route path="/leads" element={<PrivateRoute><Leads /></PrivateRoute>} />
            <Route path="/stampingpartners" element={<PrivateRoute> <RoleRoute blockedRoles={[4]}> <StampingPartners /></RoleRoute> </PrivateRoute>} />
            <Route path="/planset" element={<PrivateRoute>  <RoleRoute blockedRoles={[4]}> <PlanSet /></RoleRoute> </PrivateRoute>} />
            <Route path="/planset/order" element={<PrivateRoute>  <RoleRoute blockedRoles={[4]}> <PlansetOrder /></RoleRoute> </PrivateRoute>} />
            <Route path="/planset/view" element={<PrivateRoute> <RoleRoute blockedRoles={[4]}> <PlansetView /></RoleRoute> </PrivateRoute>} />
            <Route path="/team" element={<PrivateRoute>  <RoleRoute blockedRoles={[4]}> <TeamMain /></RoleRoute> </PrivateRoute>} />
            <Route path="/clients" element={<PrivateRoute> <RoleRoute blockedRoles={[3,4]}> <ClientMain /></RoleRoute> </PrivateRoute>} />
            <Route path="/about" element={<PrivateRoute><About /></PrivateRoute>} />
            <Route path="/reviewwithai" element={<PrivateRoute>  <RoleRoute blockedRoles={[4]}> <ReviewWithAI/></RoleRoute> </PrivateRoute>} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
        </ThemeProvider>
  );
}

export default App;
